import chatbotModel from '../../models/chatbot/chatbot.model';

// ---------------------------------------------------------------------------
// Minimal Markdown renderer (no external deps)
// Converts a Markdown string to an HTML string.
// Handles: headings, bold, italic, code blocks, inline code, lists, tables,
//          blockquotes, horizontal rules, links, paragraphs.
// ---------------------------------------------------------------------------
// function renderMarkdown(md) {
//   if (!md) return '';

//   let html = md;

//   // Escape HTML in code blocks first, then restore after
//   const codeBlocks = [];
//   html = html.replace(/```[\w]*\n?([\s\S]*?)```/g, (_, code) => {
//     const escaped = code
//       .replace(/&/g, '&amp;')
//       .replace(/</g, '&lt;')
//       .replace(/>/g, '&gt;');
//     const idx = codeBlocks.push(`<pre><code>${escaped}</code></pre>`) - 1;
//     return `\x00CODE${idx}\x00`;
//   });

//   // Inline code
//   html = html.replace(/`([^`]+)`/g, (_, c) =>
//     `<code>${c.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>`
//   );

//   // Headings
//   html = html.replace(/^#{6}\s+(.+)$/gm, '<h6>$1</h6>');
//   html = html.replace(/^#{5}\s+(.+)$/gm, '<h5>$1</h5>');
//   html = html.replace(/^#{4}\s+(.+)$/gm, '<h4>$1</h4>');
//   html = html.replace(/^#{3}\s+(.+)$/gm, '<h3>$1</h3>');
//   html = html.replace(/^#{2}\s+(.+)$/gm, '<h2>$1</h2>');
//   html = html.replace(/^#{1}\s+(.+)$/gm, '<h1>$1</h1>');

//   // Bold / italic
//   html = html.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
//   html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
//   html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
//   html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
//   html = html.replace(/_(.+?)_/g, '<em>$1</em>');

//   // Horizontal rule
//   html = html.replace(/^(?:---|\*\*\*|___)\s*$/gm, '<hr>');

//   // Blockquote
//   html = html.replace(/^&gt;\s?(.*)$/gm, '<blockquote>$1</blockquote>');
//   html = html.replace(/^>\s?(.*)$/gm, '<blockquote>$1</blockquote>');

//   // Links  [text](url)
//   html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g,
//     '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

//   // Unordered lists
//   html = html.replace(/^[*\-+]\s+(.+)$/gm, '<li>$1</li>');
//   html = html.replace(/(<li>[\s\S]*?<\/li>)(?!\s*<li>)/g, '<ul>$1</ul>');

//   // Ordered lists
//   html = html.replace(/^\d+\.\s+(.+)$/gm, '<li>$1</li>');

//   // Simple tables  (GFM-style)
//   html = html.replace(/^\|(.+)\|\s*\n\|[-| :]+\|\s*\n((?:\|.+\|\s*\n?)*)/gm,
//     (match, header, rows) => {
//       const ths = header.split('|').filter(c => c.trim()).map(c =>
//         `<th>${c.trim()}</th>`).join('');
//       const trs = rows.trim().split('\n').map(row => {
//         const tds = row.split('|').filter(c => c.trim()).map(c =>
//           `<td>${c.trim()}</td>`).join('');
//         return `<tr>${tds}</tr>`;
//       }).join('');
//       return `<table><thead><tr>${ths}</tr></thead><tbody>${trs}</tbody></table>`;
//     });

//   // Paragraphs — wrap lines not already wrapped
//   const lines = html.split('\n');
//   const out = [];
//   let buffer = [];

//   const flushBuffer = () => {
//     if (buffer.length) {
//       const text = buffer.join(' ').trim();
//       if (text) out.push(`<p>${text}</p>`);
//       buffer = [];
//     }
//   };

//   const blockTags = /^<(h[1-6]|ul|ol|li|pre|blockquote|hr|table|thead|tbody|tr|th|td|\x00CODE)/;

//   lines.forEach(line => {
//     if (blockTags.test(line.trim())) {
//       flushBuffer();
//       out.push(line);
//     } else if (line.trim() === '') {
//       flushBuffer();
//     } else {
//       buffer.push(line);
//     }
//   });
//   flushBuffer();
//   html = out.join('\n');

//   // Restore code blocks
//   codeBlocks.forEach((block, idx) => {
//     html = html.replace(`\x00CODE${idx}\x00`, block);
//   });

//   return html;
// }

// ---------------------------------------------------------------------------
// ChatbotView  –  Mithril component
// ---------------------------------------------------------------------------
export default function ChatbotView() {
  // ---- State ----------------------------------------------------------------
  let historyList = [];
  let activeSessionId = null;

  // Per-session message store so switching sessions preserves conversations
  const sessionMessages = {};

  let inputText = '';
  let isSending = false;
  let errorMsg = '';

  function loadChatLog() {
    chatbotModel.getChatLog()
      .then((res) => {
        const sessions = (res && res.sessions) || [];
        historyList = sessions.map((s, i) => ({
          sessionId: s.sessionId,
          topic: s.topic,
          active: i === 0,
        }));
        if (historyList.length > 0) {
          activeSessionId = historyList[0].sessionId;
          historyList[0].active = true;
        }
        m.redraw();
      })
      .catch(() => {
        historyList = [];
        activeSessionId = null;
        m.redraw();
      });
  }

  function getMessages() {
    return sessionMessages[activeSessionId] || [];
  }

  function setMessages(msgs) {
    sessionMessages[activeSessionId] = msgs;
  }

  // ---- Helpers ---------------------------------------------------------------
  function getActiveTitle() {
    const active = historyList.find(h => h.sessionId === activeSessionId);
    return active ? active.topic : 'New Chat';
  }

  function selectSession(sessionId) {
    historyList.forEach(h => h.active = h.sessionId === sessionId);
    activeSessionId = sessionId;
    errorMsg = '';

    // Load conversation for the selected session
    chatbotModel.getChatSession(sessionId)
      .then((messages) => {
        const conv = (messages || []).map(m => [
          { role: 'user', content: m.message || '' },
          { role: 'assistant', content: m.reply || '' },
        ]).flat();
        sessionMessages[sessionId] = conv;
        m.redraw();
        setTimeout(scrollToBottom, 50);
      })
      .catch(() => {
        sessionMessages[sessionId] = [];
        m.redraw();
      });
  }

  function startNewChat() {
    historyList.forEach(h => h.active = false);
    activeSessionId = null;
    for (const key in sessionMessages) delete sessionMessages[key];
    errorMsg = '';
    m.redraw();
  }

  function scrollToBottom() {
    const thread = document.querySelector('.chatbot-thread');
    if (thread) {
      thread.scrollTop = thread.scrollHeight;
    }
  }

  function handleInput(e) {
    inputText = e.target.value;
    // Auto-resize textarea
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 140) + 'px';
  }

  function handleKeydown(e) {
    // Send on Enter (but not Shift+Enter)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  function sendMessage() {
    const text = inputText.trim();
    if (!text || isSending) return;

    errorMsg = '';
    const isNewChat = !activeSessionId;
    // Use a temp key for messages before backend assigns a sessionId
    const storeKey = isNewChat ? '__temp__' : activeSessionId;
    const msgs = sessionMessages[storeKey] || [];
    msgs.push({ role: 'user', content: text });
    sessionMessages[storeKey] = msgs;
    inputText = '';
    isSending = true;

    const ta = document.querySelector('.chatbot-input__textarea');
    if (ta) { ta.value = ''; ta.style.height = 'auto'; }

    m.redraw();
    setTimeout(scrollToBottom, 50);

    chatbotModel.getChatLog()
      .then((res) => {
        const sessions = (res && res.sessions) || [];
        historyList = sessions.map((s) => ({
          sessionId: s.sessionId,
          topic: s.topic,
          active: s.sessionId === activeSessionId,
        }));
        m.redraw();
      })
      .catch((err) => {
        console.error('Failed to update history list before sending message:', err);
      })
      .then(() => chatbotModel.sendMessage(isNewChat ? null : activeSessionId, text))
      .then((res) => {
        // If new chat, migrate temp messages to the real sessionId
        if (isNewChat && res.sessionId) {
          activeSessionId = res.sessionId;
          sessionMessages[activeSessionId] = sessionMessages['__temp__'] || [];
          delete sessionMessages['__temp__'];
          historyList.unshift({
            sessionId: res.sessionId,
            topic: text.slice(0, 60),
            active: true,
          });
        }

        const currentMsgs = sessionMessages[activeSessionId] || [];
        currentMsgs.push({ role: 'assistant', content: res.reply || '' });
        sessionMessages[activeSessionId] = currentMsgs;
        isSending = false;
        m.redraw();
        setTimeout(scrollToBottom, 50);
      })
      .catch((err) => {
        isSending = false;
        errorMsg = 'Failed to get a response. Please try again.';
        m.redraw();
        setTimeout(scrollToBottom, 50);
      });
  }

  // ---- Render helpers --------------------------------------------------------
  function renderSidebar() {
    return m('.chatbot-sidebar', [
      m('button.chatbot-sidebar__new-btn', { onclick: startNewChat }, [
        m('i.bi.bi-plus-lg'),
        m('span', 'New Chat'),
      ]),
      m('p.chatbot-sidebar__section-label', 'Conversation History'),
      m('nav.chatbot-sidebar__nav',
        historyList.map(item =>
          m('div.chatbot-sidebar__item', {
            key: item.sessionId,
            class: item.active ? 'is-active' : '',
            onclick: () => selectSession(item.sessionId),
          }, [
            m('i.bi.bi-chat'),
            m('span.chatbot-sidebar__item-title', item.topic),
          ])
        )
      ),
    ]);
  }

  function renderUserMessage(msg, idx) {
    return m('.chatbot-message.chatbot-message--user', { key: `user-${idx}` }, [
      m('.chatbot-message__meta', m('span', 'You')),
      m('.chatbot-message__bubble',
        m('p', { style: { margin: 0 } }, msg.content)
      ),
    ]);
  }

  function renderAssistantMessage(msg, idx) {
    return m('.chatbot-message.chatbot-message--assistant', { key: `ai-${idx}` }, [
      m('.chatbot-message__meta', [
        m('.chatbot-message__avatar', m('i.bi.bi-robot')),
        m('span', 'Assistant'),
      ]),
      m('.chatbot-message__bubble',
        m.trust(msg.content)
      ),
    ]);
  }

  function renderTypingIndicator() {
    return m('.chatbot-typing', { key: 'typing' }, [
      m('.chatbot-message__meta', [
        m('.chatbot-message__avatar', m('i.bi.bi-robot')),
        m('span', 'Assistant'),
      ]),
      m('.chatbot-typing__bubble', [
        m('span.chatbot-typing__dot'),
        m('span.chatbot-typing__dot'),
        m('span.chatbot-typing__dot'),
      ]),
    ]);
  }

  function renderThread() {
    const msgs = getMessages();
    if (msgs.length === 0 && !isSending) {
      return m('.chatbot-thread', { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
        m('.chatbot-empty', [
          m('i.bi.bi-chat-dots-fill.chatbot-empty__icon'),
          m('h3', 'How can I help you today?'),
          m('p', 'Ask me anything — I\'m here to assist.'),
        ])
      );
    }

    const children = msgs.map((msg, idx) =>
      msg.role === 'user'
        ? renderUserMessage(msg, idx)
        : renderAssistantMessage(msg, idx)
    );
    if (isSending) children.push(renderTypingIndicator());
    if (errorMsg) {
      children.push(
        m('.chatbot-message.chatbot-message--assistant', { key: 'error' }, [
          m('.chatbot-message__bubble', {
            style: { color: '#ba1a1a', borderColor: '#ffdad6', background: '#fff5f5' }
          }, errorMsg)
        ])
      );
    }

    return m('.chatbot-thread', [
      m('.chatbot-thread__inner', children),
    ]);
  }

  function renderInput() {
    return m('.chatbot-input-area', [
      m('.chatbot-input-wrap', [
        m('.chatbot-input-row', [
          m('textarea.chatbot-input__textarea', {
            placeholder: 'Message Assistant…',
            rows: 1,
            value: inputText,
            disabled: isSending,
            oninput: handleInput,
            onkeydown: handleKeydown,
          }),
          m('button.chatbot-input__send', {
            disabled: !inputText.trim() || isSending,
            onclick: sendMessage,
            title: 'Send message',
          },
            m('i.bi.bi-send-fill')
          ),
        ]),
      ]),
    ]);
  }

  function adjustHeight() {
    const page = document.querySelector('.chatbot-page');
    if (!page) return;

    // Use viewport-based calculation to avoid feedback loops
    // const headerEl = document.querySelector('header') || document.querySelector('.cui-header');
    // const footerEl = document.querySelector('footer');

    // const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 56;
    // const footerTop = footerEl ? Math.max(footerEl.getBoundingClientRect().top, headerBottom + 300) : window.innerHeight;
    const barHeight = document.querySelector('#nav-bar').clientHeight;

    let chatHeight = Math.floor(Math.max(barHeight, 300))-200 + 'px';
    page.style.height = chatHeight;
    //console.log('chatHeight: '+chatHeight);
  }

  // ---- Lifecycle & view -------------------------------------------------------
  return {
    oncreate: () => {
      loadChatLog();
      requestAnimationFrame(() => {
        adjustHeight();
        scrollToBottom();
      });
      window.addEventListener('resize', adjustHeight);
    },
    onremove: () => {
      window.removeEventListener('resize', adjustHeight);
    },
    view: () => {
      return m('.chatbot-page', [
        renderSidebar(),
        m('.chatbot-main', [
          renderThread(),
          renderInput(),
        ]),
      ]);
    },
  };
}
